module.exports = __webpack_public_path__ + "img/founder2.eecbee80.jpg";